var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"left-container"},[_c('application-list',{on:{"selected":_vm.selected}})],1),_c('div',{staticClass:"right-container"},[_c('application-detail',{attrs:{"app-key":_vm.appKey}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }